import { render, staticRenderFns } from "./orderInvoice.vue?vue&type=template&id=4925892c&scoped=true"
import script from "./orderInvoice.vue?vue&type=script&lang=js"
export * from "./orderInvoice.vue?vue&type=script&lang=js"
import style0 from "./orderInvoice.vue?vue&type=style&index=0&id=4925892c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925892c",
  null
  
)

export default component.exports